/**
 * Copyright (C) Sitevision 2002-2026, all rights reserved
 */

import $ from '@sv/jquery';

export const getPortlets = (selector) => {
  if (typeof selector === 'string') {
    return $(`.${selector}`);
  }

  if (selector && selector.jquery) {
    return selector;
  }

  if (selector instanceof HTMLElement) {
    return $(selector);
  }

  return $();
};

export const getPortlet = (el) => {
  if (el) {
    const $el = el.jquery ? el : $(el);
    return $el.closest('.sv-portlet');
  }

  return $();
};
